export default {
    getSteps: (state) => (stepper) => {
        return state.steppers[stepper];
    },
    getInvestWithProviderName: (state) => {
        return state.investWith;
    },
};
